import { styled } from 'react-alicerce-components';

export const WorkedHoursAdvancedFilterContainer = styled.div`
  label {
    font-family: var(--secondary-font);
    color: var(--black);
    text-transform: unset;
    letter-spacing: 0px;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    user-select: none;
    pointer-events: none;
  }

  section {
    & + section {
      margin-top: 1.5rem;
    }
  }
`;

export const InputDateContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 14px;

  input {
    all: unset;
    font-weight: 700;
    height: 40px;
    box-sizing: border-box;
    padding: 5px;
    background: #f7f9fc;
    border: 2px solid #e4e9f2;
    border-radius: 5px;
    color: #c5cee0;
  }
`;
